import React from 'react'
import LeaveRequestTable from './Components/LeaveRequestTable'
import AddLeave from './Components/AddLeave'
import ApproveLeave from './Components/ApproveLeave'
import RejectLeave from './Components/RejectLeave'

const LeaveRequest = () => {
    return (
        <div className="px-xl-5 px-lg-4 px-3 py-3 page-body leave-management-page leave-module-shell">
            <div className="row g-3">
                <div className="col-sm-12">
                    <div className="leave-page-header d-flex align-items-start justify-content-between flex-wrap gap-3">
                        <div>
                            <span className="leave-page-kicker">Leave Approval</span>
                            <h3 className="fw-bold mb-1 leave-page-title">Leave Applications</h3>
                            <p className="mb-0 leave-page-description">
                                Monitor, export, and review employee leave applications.
                            </p>
                        </div>
                        {/* <div className="col-auto d-flex w-sm-100">
                            <button type="button" className="btn btn-dark btn-set-task w-sm-100" data-bs-toggle="modal" data-bs-target="#leaveadd">Add Leave</button>
                        </div> */}
                    </div>
                </div>
                <div className="col-sm-12">
                    <div className="card leave-surface-card">
                        <div className="card-body leave-surface-body">
                            <LeaveRequestTable />
                        </div>
                    </div>
                </div>
            </div>
            <AddLeave />
            <ApproveLeave />
            <RejectLeave />
        </div>
    )
}

export default LeaveRequest
